// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.main-content {
  margin-top: 6.167rem;
}

.label-style {
  color: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.375rem;
}

.select-box {
  border-radius: 0.667rem;
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
  margin-bottom: 1rem;
  margin-top: 0.75rem;
}

.title-page {
  color: var(--color-primary-blue);
  font-weight: bold;
  font-size: 0.967rem;
  text-align: center;
}

.buttons-main-style {
  margin-left: 2rem;
}

.back-btn {
  width: 2rem;
  cursor: pointer;
}

.title-row-margin {
  margin-top: 2.583rem;
}

ion-select > label,
ion-select,
ion-item {
  min-height: 3.667rem;
  --min-height: 3.667rem;
  height: 3.667rem;
  color: var(--color-primary-blue);
  --border-radius: 0.667rem;
}

ion-input {
  font-size: 1.333rem;
}

ion-select {
  --padding-start: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  font-size: 1.333rem;
}

.join-btn {
  min-width: 14rem;
  height: 2.667rem;
  min-height: 2.667rem;
  --min-height: 2.667rem;
  font-size: 1.167rem;
  line-height: 1.583rem;
  margin-top: 3.333rem;
}

.ion-class-col {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.ion-class-col .avatar-div {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
}
.ion-class-col .avatar-div .avatar-multiplayer {
  width: 5.125rem;
  height: 9.625rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/multiplayer-join/multiplayer-join.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,uBAAA;EACA,iFAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;;;EAGE,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;AAAF;AAEE;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;AAAN","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.main-content {\n  margin-top: 6.167rem;\n}\n\n.label-style {\n  color: var(--color-primary-blue);\n  font-size: 1rem;\n  line-height: 1.375rem;\n}\n\n.select-box {\n  border-radius: 0.667rem;\n  box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;\n  margin-bottom: 1rem;\n  margin-top: 0.75rem;\n}\n\n.title-page {\n  color: var(--color-primary-blue);\n  font-weight: bold;\n  font-size: 0.967rem;\n  text-align: center;\n}\n\n\n.buttons-main-style {\n  margin-left: 2rem;\n}\n\n.back-btn {\n  width: 2rem;\n  cursor: pointer;\n}\n\n.title-row-margin {\n  margin-top: 2.583rem;\n}\n\nion-select > label,\nion-select,\nion-item {\n  min-height: 3.667rem;\n  --min-height: 3.667rem;\n  height: 3.667rem;\n  color: var(--color-primary-blue);\n  --border-radius: 0.667rem;\n}\n\nion-input {\n  font-size: 1.333rem;\n}\n\nion-select {\n  --padding-start: 0;\n  --padding-bottom: 0;\n  --padding-top: 0;\n  font-size: 1.333rem;\n}\n\n.join-btn {\n  min-width: 14rem;\n  height: 2.667rem;\n  min-height: 2.667rem;\n  --min-height: 2.667rem;\n  font-size: 1.167rem;\n  line-height: 1.583rem;\n  margin-top: 3.333rem;\n}\n\n.ion-class-col {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n\n  .avatar-div {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 0.5rem;\n\n    .avatar-multiplayer {\n      width: 5.125rem;\n      height: 9.625rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
